/**
 * @file コンポーネント：フル動画ページ症例基本データ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledData = styled.div`
    margin: 0 auto 16px;
    padding: 0 16px;
`;

export const StyledDataContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 8px;
`;

export const StyledDataContentActionlist = styled.ul`
    display: flex;
    align-items: center;
    margin: 0 0 8px auto;
`;

export const StyledDataContentActionlistItem = styled.li`
    margin-right: 8px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledDataContentMetalist = styled.dl`
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

export const StyledDataContentMetalistDetail = styled.dd`
    color: #ffffff;
    font-size: 16px;
    line-height: 16px;
`;

export const StyledDataContentMetalistItem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 16px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledDataContentMetalistTerm = styled.dt`
    margin-right: 4px;
    color: #ffffff;
    font-size: 20px;
    line-height: 20px;
`;

export const StyledDataContents = styled.div`
    display: none;
    padding-top: 14px;

    &.is-open {
        display: block;
    }
`;

export const StyledDataEdit = styled.div`
    margin-left: 16px;
`;

export const StyledDataEditLink = styled.a`
    color: #eed393;
    font-size: 11px;
    line-height: 16px;
    white-space: nowrap;
`;

export const StyledDataEditLinkIcon = styled.span`
    margin-right: 4px;
`;

export const StyledDataEditLinkText = styled.span``;

export const StyledDataLabel = styled.div`
    padding: 4px;
    font-size: 13px;
    line-height: 16px;

    &[data-label-type="edit"] {
        background-color: #e0b03b;
        color: #000000;
    }

    &[data-label-type="paid"] {
        background-color: #00b700;
        color: #ffffff;
    }

    &[data-label-type="purchased"] {
        background-color: #acadae;
        color: #000000;
    }
`;

export const StyledDataLabellist = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: -4px -8px 4px 0;
`;

export const StyledDataLabellistItem = styled.li`
    display: flex;
    align-items: center;
    margin: 4px 8px 4px 0;
`;

export const StyledDataSurgeonlist = styled.div`
    margin-bottom: 13px;
`;

export const StyledDataTitle = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding-right: 36px;
`;

export const StyledDataTitleButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 36px;
    height: 36px;
    margin: auto 0;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #ffffff;
    font-size: 20px;
    line-height: 36px;
    text-align: center;
`;

export const StyledDataTitleText = styled.h1`
    color: #ffffff;
    font-weight: bold;
    font-size: 16px;
    line-height: 36px;

    ${mediaQuery.pc(`
        font-size: 20px;
        line-height: 36px;
    `)};
 
    ${mediaQuery.pcWide(`
        font-size: 20px;
        line-height: 36px;
    `)};
`;
